module.exports = __webpack_public_path__ + "static/media/6.f05f7527.jpg";